export const POINT_USAGE_UNIT = 1000;
export const MINIMUM_POINT_USAGE = POINT_USAGE_UNIT;

const toNonNegativeFiniteNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : 0;
};

const isNonNegativeSafeInteger = (value) => {
  return typeof value === 'number' && Number.isSafeInteger(value) && value >= 0;
};

export const floorPointUsage = (value) => {
  const number = toNonNegativeFiniteNumber(value);
  return Math.floor(number / POINT_USAGE_UNIT) * POINT_USAGE_UNIT;
};

export const getMaxUsablePoint = (ownedPoints, payableAmount) => {
  if (!isNonNegativeSafeInteger(ownedPoints) || !isNonNegativeSafeInteger(payableAmount)) return 0;

  const limit = Math.min(ownedPoints, payableAmount);
  const largestUnitAmount = floorPointUsage(limit);
  const payableRemainder = payableAmount % POINT_USAGE_UNIT;
  const largestRemainderAmount =
    payableRemainder > 0 && limit >= payableRemainder
      ? floorPointUsage(limit - payableRemainder) + payableRemainder
      : 0;

  return Math.max(largestUnitAmount, largestRemainderAmount);
};

export const getAdjustedManualPointUsage = (requestedPoints, ownedPoints, payableAmount) => {
  if (
    !isNonNegativeSafeInteger(requestedPoints) ||
    !isNonNegativeSafeInteger(ownedPoints) ||
    !isNonNegativeSafeInteger(payableAmount) ||
    requestedPoints <= 0
  )
    return 0;

  return getMaxUsablePoint(Math.min(requestedPoints, ownedPoints), payableAmount);
};

export const getAllUsePointAmount = (ownedPoints, payableAmount) =>
  getMaxUsablePoint(ownedPoints, payableAmount);

export const isValidPointUsageRequest = (value, ownedPoints, payableAmount) => {
  if (!isNonNegativeSafeInteger(value)) return false;
  if (value === 0) return true;
  if (!isNonNegativeSafeInteger(ownedPoints) || !isNonNegativeSafeInteger(payableAmount)) return false;
  if (value > ownedPoints || value > payableAmount) return false;

  const payableRemainder = payableAmount % POINT_USAGE_UNIT;
  return (
    value % POINT_USAGE_UNIT === 0 ||
    (payableRemainder > 0 && value % POINT_USAGE_UNIT === payableRemainder)
  );
};

export const isValidOrderPointUsageRequest = (
  value,
  ownedPoints,
  payableAmount,
  isPointAvailable
) =>
  isValidPointUsageRequest(value, ownedPoints, payableAmount) &&
  (value === 0 || isPointAvailable === true);

export const isValidManualPointUsage = (value, ownedPoints, payableAmount) =>
  isValidPointUsageRequest(value, ownedPoints, payableAmount);
